const stateCountry = [
  { key: 'AGU', value: 'MEX' },
  { key: 'BCN', value: 'MEX' },
  { key: 'BCS', value: 'MEX' },
  { key: 'CAM', value: 'MEX' },
  { key: 'CHP', value: 'MEX' },
  { key: 'CHH', value: 'MEX' },
  { key: 'COA', value: 'MEX' },
  { key: 'COL', value: 'MEX' },
  { key: 'DIF', value: 'MEX' },
  { key: 'DUR', value: 'MEX' },
  { key: 'GUA', value: 'MEX' },
  { key: 'GRO', value: 'MEX' },
  { key: 'HID', value: 'MEX' },
  { key: 'JAL', value: 'MEX' },
  { key: 'MEX', value: 'MEX' },
  { key: 'MIC', value: 'MEX' },
  { key: 'MOR', value: 'MEX' },
  { key: 'NAY', value: 'MEX' },
  { key: 'NLE', value: 'MEX' },
  { key: 'OAX', value: 'MEX' },
  { key: 'PUE', value: 'MEX' },
  { key: 'QUE', value: 'MEX' },
  { key: 'ROO', value: 'MEX' },
  { key: 'SLP', value: 'MEX' },
  { key: 'SIN', value: 'MEX' },
  { key: 'SON', value: 'MEX' },
  { key: 'TAB', value: 'MEX' },
  { key: 'TAM', value: 'MEX' },
  { key: 'TLA', value: 'MEX' },
  { key: 'VER', value: 'MEX' },
  { key: 'YUC', value: 'MEX' },
  { key: 'ZAC', value: 'MEX' },
  { key: 'AL', value: 'USA' },
  { key: 'AK', value: 'USA' },
  { key: 'AZ', value: 'USA' },
  { key: 'AR', value: 'USA' },
  { key: 'CA', value: 'USA' },
  { key: 'NC', value: 'USA' },
  { key: 'SC', value: 'USA' },
  { key: 'CO', value: 'USA' },
  { key: 'CT', value: 'USA' },
  { key: 'ND', value: 'USA' },
  { key: 'SD', value: 'USA' },
  { key: 'DE', value: 'USA' },
  { key: 'FL', value: 'USA' },
  { key: 'GA', value: 'USA' },
  { key: 'HI', value: 'USA' },
  { key: 'ID', value: 'USA' },
  { key: 'IL', value: 'USA' },
  { key: 'IN', value: 'USA' },
  { key: 'IA', value: 'USA' },
  { key: 'KS', value: 'USA' },
  { key: 'KY', value: 'USA' },
  { key: 'LA', value: 'USA' },
  { key: 'ME', value: 'USA' },
  { key: 'MD', value: 'USA' },
  { key: 'MA', value: 'USA' },
  { key: 'MI', value: 'USA' },
  { key: 'MN', value: 'USA' },
  { key: 'MS', value: 'USA' },
  { key: 'MO', value: 'USA' },
  { key: 'MT', value: 'USA' },
  { key: 'NE', value: 'USA' },
  { key: 'NV', value: 'USA' },
  { key: 'NJ', value: 'USA' },
  { key: 'NY', value: 'USA' },
  { key: 'NH', value: 'USA' },
  { key: 'NM', value: 'USA' },
  { key: 'OH', value: 'USA' },
  { key: 'OK', value: 'USA' },
  { key: 'OR', value: 'USA' },
  { key: 'PA', value: 'USA' },
  { key: 'RI', value: 'USA' },
  { key: 'TN', value: 'USA' },
  { key: 'TX', value: 'USA' },
  { key: 'UT', value: 'USA' },
  { key: 'VT', value: 'USA' },
  { key: 'VA', value: 'USA' },
  { key: 'WV', value: 'USA' },
  { key: 'WA', value: 'USA' },
  { key: 'WI', value: 'USA' },
  { key: 'WY', value: 'USA' },
  { key: 'ON', value: 'CAN' },
  { key: 'QC', value: 'CAN' },
  { key: 'NS', value: 'CAN' },
  { key: 'NB', value: 'CAN' },
  { key: 'MB', value: 'CAN' },
  { key: 'BC', value: 'CAN' },
  { key: 'PE', value: 'CAN' },
  { key: 'SK', value: 'CAN' },
  { key: 'AB', value: 'CAN' },
  { key: 'NL', value: 'CAN' },
  { key: 'NT', value: 'CAN' },
  { key: 'YT', value: 'CAN' },
  { key: 'UN', value: 'CAN' },
];

module.exports = stateCountry;
